import { useRootStore } from "@/stores/root";

export const useFilters = (params) => {
  const route = useRoute();
  const router = useRouter();
  let controller;

  const _state = useState("_state", () => {
    return {
      items: [],
      facets: "",
      total: 0,
      offset: 0,
      loadingMore: false,
    };
  });

  const loadMoreAvailable = computed(
    () => _state.value.offset < _state.value.total
  );

  const loadItems = async (endpoint, query, limit = 60) => {

    let cleanQuery;

    const rootStore = useRootStore();

    if (query) {
      // clean "referral" query parameter
      cleanQuery = { ...query };
      rootStore.excludeQueryParams.forEach((param) => {
        delete cleanQuery[param];
      });
    }

    const queryToString = (query) => {
      return Object.keys(query)
        .map((key) => `${key}=${query[key]}`)
        .join("&");
    };

    const url = `${endpoint}${cleanQuery
      ? `?${queryToString({
        lng: route.params.locale,
        items_per_page: limit,
        ...cleanQuery,
      })}`
      : ""
      }`;

    try {
      if (controller) {
        controller.abort();
      }

      controller = new AbortController();

      return $fetch(url, {
        signal: controller.signal,
      }).then((data) => {
        return data;
      });
    } catch (error) {
      console.warn("loadItems", error);
    }
  };

  const updateResults = (data, append = false) => {
    if (append) {
      _state.value.items = _state.value.items.concat(data.results || []);
    } else {
      _state.value.items = data.results || [];
    }

    _state.value.total = parseInt(data.total) || 0;
    _state.value.offset = _state.value.items.length;
    _state.value.facets = JSON.stringify(data.facets) || "";
  };

  function infiniteScroll(endpoint, limit = 60) {
    if (_state.value.loadingMore || !loadMoreAvailable.value) {
      return;
    }
    // call to load more web service here
    _state.value.loadingMore = true;
    loadItems(endpoint, {
      ...route.query,
      items_per_page: limit,
      offset: _state.value.offset,
    }).then((data) => {
      router.replace({
        path: route.path,
        query: {
          ...route.query,
          offset: _state.value.offset,
        },
      });
      updateResults(data, true);
      _state.value.loadingMore = false;
    });
  }

  return {
    loadItems,
    infiniteScroll,
    updateResults,
    loadMoreAvailable,
    loadingMore: computed(() => _state.value.loadingMore),
    items: computed(() => _state.value.items),
    facets: computed(() => _state.value.facets),
    total: computed(() => _state.value.total),
    offset: computed(() => _state.value.offset),
  };
};
